import { useState } from "react";
import { API_FETCH_STATUS } from "constants/common";
import { postFormData } from "../services/TalkToAnExpert.services";
import { generateSubmitRequestPayload } from "../utils/utils";

const { SUCCESS, LOADING, ERROR } = API_FETCH_STATUS;

const useSubmitRequest = () => {
  const [response, setResponse] = useState({ status: null, content: null });
  const { status, content } = response;
  const setStatus = (value) => setResponse({ ...response, status: value });
  const submitFormData = (e, formData, LeadProduct, LineOfBusiness, pageUrl, utmParams) => {
    e.preventDefault();
    const payload = generateSubmitRequestPayload(formData, LeadProduct, LineOfBusiness, pageUrl, utmParams);
    setResponse({ ...response, status: LOADING });
    return postFormData(payload)
      .then((response) => {
        setResponse({ status: SUCCESS, content: response });
      })
      .catch((error) => {
        setResponse({ status: ERROR, content: error });
      });
  };

  return { submitFormData, status, setStatus, content };
};

export default useSubmitRequest;
